import { ButtonSize } from 'components/ButtonDeprecated';
import Group from 'entities/Group';
import React from 'react';
import UserActionsMenuButton from 'user/components/UserActionsMenuButton';
// @ts-ignore
import mapGraphQLMemberToUserActionsMenuButtonUser from 'user/lib/mapGraphQLMemberToUserActionsMenuButtonUser';
import { UserProfile } from 'users/components/UsersProfile';
import { GroupMemberProfile_classes } from 'users/components/UsersProfile/queries/__generated__/GroupMemberProfile';

export type Props = {
  group: GroupMemberProfile_classes;
  isPrivateNoteVisible: boolean;
  member: UserProfile;
  onUserRemoved: () => void;
  onUserUpdate: (eventName?: string) => Promise<void>;
  onRevealPrivateNote: () => void;
};

export default function GroupMemberActionsMenuButton(props: Props) {
  const {
    group,
    member,
    onUserRemoved,
    onUserUpdate,
    isPrivateNoteVisible,
    onRevealPrivateNote,
  } = props;
  const { userInteractionPermissions, preferences } = member;
  const {
    canAddAsGroupOwner,
    canBlock,
    canCopyToAnotherGroup,
    canRemoveFromGroup,
    canReportToRemind,
    canBanNameChanges,
    canChangeName,
    canUpdatePreferredLanguage,
  } = userInteractionPermissions;

  return (
    <UserActionsMenuButton
      buttonSize={ButtonSize.xsmall}
      copyToClassText="Add to another class"
      glyphSize="inherit"
      groupToAdmin={Group.fromJSON(group)}
      isAdminView
      isPrivateNoteVisible={isPrivateNoteVisible}
      onRevealPrivateNote={onRevealPrivateNote}
      showAddPrivateNote
      showCopyToClass={canCopyToAnotherGroup}
      showBlockMember={canBlock}
      showMakeOwner={canAddAsGroupOwner}
      showRemoveMember={canRemoveFromGroup}
      showReportAsUser={canReportToRemind}
      user={mapGraphQLMemberToUserActionsMenuButtonUser(member)}
      onUserRemoved={onUserRemoved}
      onUserUpdate={onUserUpdate}
      tooltip="More actions"
      tooltipPlacement="top"
      canBanNameChanges={canBanNameChanges}
      canChangeName={canChangeName}
      canUpdatePreferredLanguage={canUpdatePreferredLanguage}
      preferredLanguage={preferences?.preferred_language}
    />
  );
}
